module.exports = __webpack_public_path__ + "img/red.aabf7c78.png";